import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { QrCode, X } from "lucide-react";
import { getWalkinLink } from "@/lib/api";

// New Consult: this gym's pre-sale questionnaire QR code. Tap it to show it full screen, so a
// coach can hand their phone or tablet to the prospect to scan. No printout needed. It closes only with
// the X (or Escape): on touch screens the opening tap can land again on the overlay.
// showRequest: bump it to open the QR full screen from elsewhere on the page.
export default function WalkinQrPanel({ showRequest = 0 }) {
  const [link, setLink] = useState(null);
  const [png, setPng] = useState("");
  const [big, setBig] = useState(false);
  useEffect(() => { if (showRequest) setBig(true); }, [showRequest]);

  useEffect(() => {
    getWalkinLink().then(async (l) => {
      setLink(l);
      setPng(await QRCode.toDataURL(l.url, { width: 900, margin: 2, errorCorrectionLevel: "M" }));
    }).catch(() => setLink(null));
  }, []);
  useEffect(() => {
    if (!big) return undefined;
    const onKey = (e) => e.key === "Escape" && setBig(false);
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [big]);

  if (!link || !png) return null;
  return (
    <>
      <section className="card-surface p-3 flex items-center gap-3" data-testid="walkin-qr-panel">
        <button type="button" onClick={() => setBig(true)} aria-label="Show the pre-sale questionnaire QR code full screen"
          className="shrink-0 rounded-lg bg-white p-1.5 hover:ring-2 hover:ring-rose-500">
          <img src={png} alt="" className="h-16 w-16" />
        </button>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-medium text-zinc-100">Pre-sale questionnaire</div>
          <div className="text-xs text-zinc-500">Here for a consult? Let them scan this. They'll appear under "Waiting for a consult".</div>
        </div>
        <button type="button" onClick={() => setBig(true)}
          className="shrink-0 rounded-full border border-[#262626] px-3 py-1.5 text-xs text-zinc-200 hover:border-rose-500/50">
          <QrCode className="inline h-3.5 w-3.5 mr-1 -mt-0.5" />Show
        </button>
      </section>

      {big && (
        <div className="fixed inset-0 z-[70] bg-white text-zinc-900 flex flex-col items-center justify-center gap-6 p-6"
          role="dialog" aria-modal="true" aria-label="Pre-sale questionnaire QR code"
          style={{ paddingTop: "max(env(safe-area-inset-top), 24px)", paddingBottom: "max(env(safe-area-inset-bottom), 24px)" }}>
          <button type="button" aria-label="Close" onClick={() => setBig(false)} className="absolute right-4 top-4 p-2 text-zinc-500">
            <X className="h-7 w-7" />
          </button>
          <div className="text-center">
            <div className="font-display text-3xl font-extrabold uppercase">Welcome to LIFTR</div>
            <div className="mt-1 text-lg text-zinc-600">Scan with your phone camera to get started</div>
          </div>
          <img src={png} alt={`QR code for ${link.url}`} className="w-[min(80vw,60vh)] h-[min(80vw,60vh)]" />
          <div className="text-sm text-zinc-500 select-all">{link.url.replace("https://", "")}</div>
        </div>
      )}
    </>
  );
}
